<div class="propero-about">
  <section class="ph-hero ph-hero--compact">
    <div class="ph-hero__blob ph-hero__blob--brand" aria-hidden="true"></div>
    <div class="ph-hero__blob ph-hero__blob--accent" aria-hidden="true"></div>

    <div class="ph-container ph-hero__content--centered">
      <p class="ph-hero__eyebrow">{{ 'ABOUT_US.HERO.EYEBROW' | translate }}</p>
      <h1 class="ph-hero__title">{{ 'ABOUT_US.HERO.TITLE' | translate }}</h1>
      <p class="ph-hero__subtitle">{{ 'ABOUT_US.HERO.SUBTITLE' | translate }}</p>
      <div class="ph-hero__actions">
        <a routerLink="/contact" class="ph-btn ph-btn--brand ph-btn--lg">{{ 'ABOUT_US.HERO.CTA' | translate }}</a>
        <a routerLink="/pricing" class="ph-btn ph-btn--outline ph-btn--lg">{{ 'ABOUT_US.HERO.CTA_SECONDARY' | translate }}</a>
      </div>
    </div>
  </section>

  <section class="ph-section ph-about-stats">
    <div class="ph-container">
      <div class="ph-stats">
        <div class="ph-stats__item">
          <div class="ph-stats__value">{{ 'HOME.STATISTICS_ACTIVE_CLIENTS' | translate }}</div>
          <div class="ph-stats__label">{{ 'HOME.STATISTICS_ACTIVE_CLIENTS_TEXT' | translate }}</div>
        </div>
        <div class="ph-stats__item">
          <div class="ph-stats__value">{{ 'HOME.STATISTICS_SUCCESS_RATE' | translate }}</div>
          <div class="ph-stats__label">{{ 'HOME.STATISTICS_SUCCESS_RATE_TEXT' | translate }}</div>
        </div>
        <div class="ph-stats__item">
          <div class="ph-stats__value">24/7</div>
          <div class="ph-stats__label">{{ 'HOME.DEDICATED_SUPPORT_TEXT' | translate }}</div>
        </div>
      </div>
    </div>
  </section>

  <section class="ph-section ph-section--muted">
    <div class="ph-container ph-about-duo">
      <article class="ph-card ph-card--hover">
        <p class="ph-section__eyebrow">{{ 'ABOUT_US.MISSION.EYEBROW' | translate }}</p>
        <h2 class="ph-card__title-sm">{{ 'ABOUT_US.MISSION.TITLE' | translate }}</h2>
        <p class="ph-card__text ph-card__text--muted">{{ 'ABOUT_US.MISSION.TEXT' | translate }}</p>
      </article>
      <article class="ph-card ph-card--hover ph-card--dark">
        <p class="ph-card__tag ph-card__tag--accent">{{ 'ABOUT_US.TEAM.EYEBROW' | translate }}</p>
        <h2 class="ph-card__title-sm">{{ 'ABOUT_US.TEAM.TITLE' | translate }}</h2>
        <p class="ph-card__text">{{ 'ABOUT_US.TEAM.TEXT' | translate }}</p>
      </article>
    </div>
  </section>

  <section class="ph-section">
    <div class="ph-container">
      <header class="ph-section__header ph-section__header--center">
        <p class="ph-section__eyebrow">{{ 'ABOUT_US.VALUES.EYEBROW' | translate }}</p>
        <h2 class="ph-section__title">{{ 'ABOUT_US.VALUES.TITLE' | translate }}</h2>
      </header>
      <div class="ph-about-values__grid">
        <article *ngFor="let pillar of valuePillars" class="ph-about-value">
          <div class="ph-about-value__icon" aria-hidden="true">
            <i class="lni" [ngClass]="pillar.icon"></i>
          </div>
          <h3 class="ph-about-value__title">{{ pillar.titleKey | translate }}</h3>
          <p class="ph-about-value__text">{{ pillar.textKey | translate }}</p>
        </article>
      </div>
    </div>
  </section>

  <section class="ph-section ph-section--muted">
    <div class="ph-container">
      <header class="ph-section__header ph-section__header--center">
        <p class="ph-section__eyebrow">{{ 'ABOUT_US.MILESTONES.EYEBROW' | translate }}</p>
        <h2 class="ph-section__title">{{ 'ABOUT_US.MILESTONES.TITLE' | translate }}</h2>
        <p class="ph-section__lead">{{ 'ABOUT_US.MILESTONES.LEAD' | translate }}</p>
      </header>
      <div class="ph-milestones">
        <article
          *ngFor="let item of milestones"
          class="ph-milestone"
          [class.ph-milestone--future]="item.future">
          <span class="ph-milestone__year">{{ item.year }}</span>
          <h3 class="ph-milestone__title">{{ item.titleKey | translate }}</h3>
          <p class="ph-milestone__text">{{ item.textKey | translate }}</p>
        </article>
      </div>
    </div>
  </section>

  <section class="ph-section ph-about-cta">
    <div class="ph-container">
      <div class="ph-about-cta__panel">
        <h2 class="ph-about-cta__title">{{ 'ABOUT_US.CTA.TITLE' | translate }}</h2>
        <p class="ph-about-cta__text">{{ 'ABOUT_US.CTA.TEXT' | translate }}</p>
        <div class="ph-about-cta__actions">
          <a routerLink="/contact" class="ph-btn ph-btn--brand ph-btn--lg">{{ 'ABOUT_US.CTA.PRIMARY' | translate }}</a>
          <a [href]="assistantHref" target="_blank" rel="noopener noreferrer" class="ph-btn ph-btn--outline ph-btn--lg ph-btn--on-dark">
            Propero Assistant
          </a>
        </div>
      </div>
    </div>
  </section>
</div>
